import { CloseCircleOutlined } from '@ant-design/icons';
import { Col } from 'antd';
import { message } from 'antd';
import { Row } from 'antd';
import { Form } from 'antd';
import { Typography } from 'antd';
import { useEffect } from 'react';
import { useState } from 'react';
import { Enviroment } from '../../_config/constants/enviroment-v2.constant';
import CustomButton from '../../v2-components/Antd/Button';
import CustomCard from '../../v2-components/Antd/Card';
import CustomFormItem from '../../v2-components/Antd/FormItem';
// import CustomRadio from '../../v2-components/Antd/Radio';
// import CustomRadioGroup from '../../v2-components/Antd/RadioGroup';
import CustomSelect from '../../v2-components/Antd/Select';
import CustomUpload from '../../v2-components/Antd/Upload';
import Pharmacies from '../../v2-components/Pharmacies';
import ResponseCollapse from '../../v2-components/ResponseCollapse';
import { dictionary } from './constants/dictionary.constant';
import { Links } from './constants/link-examples.constant';
import { messages } from './constants/messages.constant';
import { states } from './constants/states.constant';
import { boxStatus } from './handle/box-status.handle';
// import { checkRadioValue } from './handle/check-radio-value.handle';
// import { checkSelectOptions } from './handle/check-select-options.handle';
import { importFileAdapter } from './handle/import-file-adapter.handle';
import { pharmacyOptions } from './handle/pharmacy-options.handle';
import { Service } from './service';
import './style.css';
import Loading from '../../v2-components/Loading';
import { optionsPharmacy } from './constants/options-pharmacy.constant';
const { Title } = Typography;

export default function AdminMigrationPage() {
	const [selectedInfo, setSelectedInfo] = useState(null);
	const [status, setStatus] = useState(null);
	const [migration, setMigration] = useState({});
	const [file, setFile] = useState({});
	const [error, setError] = useState('');
	const [msg, setMsg] = useState('');
	const [pharmacy, setPharmacy] = useState(null);
	const [options, setOptions] = useState();
	const [responseError, setResponseError] = useState('');
	// const [radioValue, setRadioValue] = useState('pharmacy');
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		Promise.all([new Service().generatePharmacy(pharmacy), new Service().getPharmacies(), new Service().generateMarketplace(pharmacy)])
			.then(([migrationResponse, pharmaciesResponse, migrationMarketplaceResponse]) => {
				console.log('[MIGRATION-RESPONSE]', migrationResponse);
				console.log('[MIGRATIONMARKETPLACE-RESPONSE]', migrationMarketplaceResponse);

				setIsLoading(false);
				if (migrationResponse.token) {
					setMigration(migrationResponse);
				}
				if (migrationMarketplaceResponse[0]?.token) {
					setMigration(migrationMarketplaceResponse[0]);
				}
				setOptions(pharmacyOptions(pharmaciesResponse?.data));
			})

			.catch((error) => {
				console.error('Error en la solicitud:', error);
			});
	}, [pharmacy]);

	const handleUpload = (info) => {
		if (info.fileList.length > 0) {
			setFile(info.fileList[0]);
		}
	};

	const beforeUpload = (file) => {
		const validateTypes = ['.xls', '.xlsx'];
		const extension = file.name?.substring(file.name.lastIndexOf('.')).toLowerCase();
		if (!validateTypes.includes(extension)) {
			return message.error(messages[Enviroment.LANGUAGE].invalid);
		}
		return;
	};

	const handleFileUpload = () => {
		setStatus(states[Enviroment.LANGUAGE].uploading);
		const form = new FormData();
		form.append('file', file.originFileObj);

		new Service()
			.importFile(importFileAdapter(file, migration.token, selectedInfo, form))
			.then((res) => {
				if (res.statusCode === 400) {
					setError(messages[Enviroment.LANGUAGE].error);
					setResponseError(res.error.message);
					setStatus(states[Enviroment.LANGUAGE].error);
					return;
				}
				if (res.statusCode === 500) {
					setError(messages[Enviroment.LANGUAGE].error);
					setResponseError(messages[Enviroment.LANGUAGE].error);
					setStatus(states[Enviroment.LANGUAGE].error);
					return;
				}
				setMsg(messages[Enviroment.LANGUAGE].success);
				setStatus(states[Enviroment.LANGUAGE].done);
				console.log(res);
			})
			.catch((error) => {
				setError(messages[Enviroment.LANGUAGE].error);
				setStatus(states[Enviroment.LANGUAGE].error);
				setResponseError(error.message);
				console.log('ERROR', error);
			});
	};
	console.log('SELECTED INFO', selectedInfo)


	// const onChange = (e) => {
	// 	setSelectedInfo(null);
	// 	setRadioValue(e.target.value);
	// 	if (e.target.value === dictionary[Enviroment.LANGUAGE].marketplace) {
	// 		setPharmacy('pharol');
	// 	}
	// };

	const handleSelectInfo = (value) => {
		setSelectedInfo(value);
	};

	const handleSelectChange = (value) => {
		setPharmacy(value);
	};

	const handleInnerClick = (e) => {
		e.stopPropagation();
	};

	if (isLoading) {
		return <Loading /> ;
	}

	return (
		<div className='admin-migration-container'>
		<CustomCard>
			<Title level={2}>Migración</Title>
			{/* <Title level={4}>Seleccionar el tipo de carga a realizar</Title>
			<CustomRadioGroup onChange={onChange} value={radioValue}>
				<CustomRadio value={dictionary[Enviroment.LANGUAGE]?.marketplace}>Marketplace</CustomRadio>
				<CustomRadio value={dictionary[Enviroment.LANGUAGE]?.pharmacy}>Farmacia</CustomRadio>
			</CustomRadioGroup> */}

			<Pharmacies
				className={'select-pharmacies'}
				value={pharmacy === dictionary[Enviroment.LANGUAGE].pharol ? null : pharmacy}
				options={options}
				onChange={handleSelectChange}
				// disabled={checkRadioValue(radioValue)}
			/>

			<Col>
				<Form>
					<Row>
						<Title level={4}>Seleccionar el tipo de archivo a subir para la carga masiva</Title>
					</Row>
					<CustomFormItem label="Tipo de información" className={'select-typhology'}>
						<CustomSelect
							onChange={handleSelectInfo}
								// options={checkSelectOptions(radioValue)}
							options={optionsPharmacy[Enviroment.LANGUAGE]}
							value={selectedInfo}
							country={Enviroment.LANGUAGE}
							bordered={true}
							placeholder={'Seleccionar tipología'}
						></CustomSelect>
					</CustomFormItem>
					<Row>
						<p>
							Formato del archivo: Excel (xls, xlsx) <br />
							Cabeceras: El archivo debe contener los titulos de cada columna
							<br />
							Ejemplo:
							<a href={Links.global} target="_blank" rel="noopener noreferrer">
								Click Aqui
							</a>
						</p>
					</Row>

					<Row className="center">
						<CustomUpload
							accept=".xls, .xlsx"
							maxCount={1}
							showUploadList={false}
							listType="picture"
							customRequest={handleFileUpload}
							beforeUpload={beforeUpload}
							multiple={false}
							onChange={(info) => handleUpload(info)}
						>
							{boxStatus(status, file?.name, msg)}
							{status === states[Enviroment.LANGUAGE].error && (
								<>
									<Row className="fail">
										<CloseCircleOutlined className="iconFail" />
										<Row className="container">
											<span className="fontBold">Error</span>
											<span className="fontBold">{file?.name}</span>
										</Row>
									</Row>
									<Col style={{ marginBottom: '20px' }} onClick={handleInnerClick}>
										<ResponseCollapse style={{ marginTop: '10px' }} userMessage={error} devMessage={responseError} />
									</Col>
								</>
							)}
							<Row>
								<CustomButton
									disabled={!selectedInfo || !pharmacy}
									onClick={() => {
										setFile({});
									}}
									type="primary"
								>
									SUBIR ARCHIVO
								</CustomButton>
							</Row>
						</CustomUpload>
					</Row>
				</Form>
			</Col>
		</CustomCard>
		</div>
	);
}
